import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const messages = {
  en: {
    global: {
      appName: 'UI Workshop',
      logIn: 'Log in',
      close: 'Close',
      cancel: 'Cancel',
      save: 'Save',
      add: 'Add',
      recommendation: 'Recommendation',
      works: 'Works',
      items: 'Parts',
      date: 'Date',
      number: '№',
      client: 'Client',
      automobile: 'Vehicle',
      plateNumber: 'LPN', //Acronym: license plate number
      months:
        'January,February,March,April,May,June,July,August,September,October,November,December',
      weekdays: 'Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday',
      weekdaysShort: 'Sun,Mon,Tue,Wed,Thu,Fri,Sat',
      onlyNumbers: 'only numbers can be entered',
      search: 'Search',
      comment: 'Comment',
      settings: 'settings',
      yield: 'Yield',
      schedule: 'Schedule',
      history: 'History',
      pickPeriod: 'Pick period',
      docList: 'Docs',
      periodFrom: 'From',
      periodTo: 'To',
      today: 'Today',
      week: 'Week',
      prevWeek: 'Previous week',
      nextWeek: 'Next week',
      month: 'Month',
      prevMonth: 'Previous month',
      period: 'Period',
      yes: 'Yes',
      no: 'No',
      camera: 'Camera',
    },
    login: {
      authorization: 'Authorization',
      googleAuth: 'Authorization with a Google account',
      barcodeLabel: 'Badge barcode',
      pinLabel: 'PIN',
      demoAuth: 'Demo auth',
      barcodeRulesEmpty: 'Enter badge barcode',
      barcodeRulesError: 'Invalid barcode format',
      pinRulesEmpty: 'Enter badge PIN',
      pinRulesError: 'Invalid PIN format',
      logInAs: 'You are logged in as',
      waitFor: 'Wait for the startup complete',
      entryError: 'Entry error',
      settingsError: 'error on getting server settings',
      authError: 'authentication error',
      logoutConfirm: 'Are you sure you want to logout?',
    },
    settings: {
      settings: 'Settings',
      serverAddress: 'Server address',
      autoLogOut: 'log out automatically',
    },
    docList: {
      listFor: 'Date',
      listInWork: 'Documents in work',
      listArchive: 'Archived documents',
      searchLabel: '№ doc. / LPN', //Acronym: license plate number
      barcodeLabel: 'Document barcode',
      noDocs: 'No documents for the date',
      listSettings: 'list settings',
      rememberDate: 'Remember date',
      docSelectionError: 'Document selection error',
      docGettingError: 'Document getting error',
      docNotFound: 'Document not found',
      docDataError: 'Getting document data error',
    },
    docZN: {
      ZN: 'Order',
      dated: 'dated',
      atWork: 'in process:',
      min: 'min',
      works: 'Works',
      items: 'Parts',
      recommendations: 'Recommendations',
      noRows: 'No data',
      worksColumnIndex: '№',
      worksColumnWorkName: 'Name',
      worksColumnCount: 's/h', //standard hour ??
      worksColumnPrice: 'per/h',
      worksColumnWorkerName: 'Mechanic',
      worksColumnOnHand: '',
      worksColumnNorm: 'Norm',
      goodsColumnIndex: '№',
      goodsColumnProductName: 'Part name',
      goodsColumnCount: 'Count',
      goodsColumnMeasureName: 'Unit',
      goodsColumnStorageName: 'Storage',
      goodsColumnOnHand: '',
      recommendationColumnIndex: '№',
      recommendationColumnWorkName: 'Work name',
      recommendationColumnWorkerName: 'Mechanic',
      recommendationColumnStatus: '',
      documentDataError: 'Error getting document data',
      recommendationsSaved: 'Recommendations saved successfully',
      documentSaved: 'Document saved successfully',
      documentSaveError: 'Error saving document',
      commentTo: 'Comment to',
      documentIsPostedError:
        'The document has been posted and cannot be saved!',
      countChanged: 'Quantity changed!',
      reason: 'Reason for contact',
      questionnaireAbsent: 'Check list is not adjusted',
    },
    carHistory: {
      carHistory: 'Car history',
      enterSearchValue: 'Enter the VIN or car plate number to search data',
      carHistoryDataError: 'Error getting car history data',
    },
    questionnaireForm: {
      signSurvey: 'Sign a survey',
      formColumnStartTime: 'Start',
      formColumnEndTime: 'End',
      formColumnWork: 'Work',
      formDataError: 'Error getting survey data',
      formSaveError: 'Survey recording error',
    },
    userCard: {
      startDateLabel: 'Card from',
      salary: 'salary',
      accruedSalary: 'accrued salary',
      salaryPaid: 'salary paid',
      endDateLabel: 'to',
      noDataError: 'user timesheet data not found',
      workingOutPerMonth: 'Hours per month',
      dataCompositionWarning:
        'only closed posted documents are included in the calculation',
      dateDocTitle: 'Date / Doc',
      timesheetTitle: 'Timesheet',
      factByDocumentsTitle: 'Counter by doc',
      factByWorksTitle: 'Counter by work',
      usercardColumnWork: 'Work',
      usercardColumnWorkingOut: 'Charged hours',
      usercardColumnFact: 'Fact hours',
      userDataError: 'Error: user timesheet data getting error',
      otherError: 'Error',
      showFactColumns: 'show сounter colnums',
    },
    workPlan: {
      workPlanDataError: 'Error getting work Plan',
      workPlanIsEmpty: 'Work plan for the current week is empty',
      carIsEmpty: 'Empty auto',
      titleFrom: 'Work plan from',
      titleTo: 'to',
      workCompleted: 'work completed',
      docNotFound: 'Документ не найден',
    },
  },
  ru: {
    global: {
      appName: 'АРМ Механика',
      logIn: 'Войти',
      close: 'Закрыть',
      cancel: 'Отменить',
      save: 'Записать',
      add: 'Добавить',
      recommendation: 'Рекомендация',
      works: 'Работы',
      items: 'Детали',
      date: 'Дата',
      number: '№',
      client: 'Клиент',
      automobile: 'Автомобиль',
      plateNumber: 'гос. номер',
      months:
        'Январь,Февраль,Март,Апрель,Май,Июнь,Июль,Август,Сентябрь,Октябрь,Ноябрь,Декабрь',
      weekdays: 'Воскресенье,Понедельник,Вторник,Среда,Четверг,Пятница,Суббота',
      weekdaysShort: 'Вск,Пон,Вт,Ср,Чтв,Птн,Суб',
      onlyNumbers: 'можно вводить только цифры',
      search: 'Поиск',
      comment: 'Комментарий',
      settings: 'настройки',
      yield: 'Выработка',
      schedule: 'План',
      history: 'История',
      docList: 'Документы',
      pickPeriod: 'Выберите период',
      periodFrom: 'Дата начала',
      periodTo: 'Дата окончания',
      today: 'Сегодня',
      week: 'Неделя',
      prevWeek: 'Прошлая неделя',
      nextWeek: 'Следующая неделя',
      month: 'Месяц',
      prevMonth: 'Прошлый месяц',
      period: 'Период',
      yes: 'Да',
      no: 'Нет',
      camera: 'Камера',
    },
    login: {
      authorization: 'Авторизация',
      googleAuth: 'Авторизация с помощью Google-аккаунта',
      barcodeLabel: 'Штрих-код бэджа',
      pinLabel: 'PIN-код',
      demoAuth: 'Тестовый вход',
      barcodeRulesEmpty: 'Введите штрих-код бэджа',
      barcodeRulesError: 'Некорректный формат штрих-кода',
      pinRulesEmpty: 'Введите PIN-код бэджа',
      pinRulesError: 'Некорректный формат PIN-кода',
      logInAs: 'Вы вошли как',
      waitFor: 'Дождитесь окончания загрузки данных',
      entryError: 'Ошибка входа',
      settingsError: 'Ошибка получения настроек сервера',
      authError: 'Ошибка аутентификации',
      logoutConfirm: 'Вы хотите выйти из приложения?',
    },
    settings: {
      settings: 'Настройки приложения',
      serverAddress: 'Адрес сервера',
      autoLogOut: 'Выходить автоматически',
    },
    docList: {
      listFor: 'Дата',
      listInWork: 'ЗН в работе',
      listArchive: 'Архив ЗН',
      searchLabel: '№ док. / гос. номер',
      barcodeLabel: 'Штрих-код документа',
      noDocs: 'Нет документов за выбранную дату',
      listSettings: 'Настройки списка',
      rememberDate: 'Запомнить дату',
      docSelectionError: 'Ошибка выборки документов',
      docGettingError: 'Ошибка получения документа',
      docNotFound: 'Документ не найден',
      docDataError: 'Ошибка получения данных документа',
    },
    docZN: {
      ZN: 'ЗН',
      dated: 'от',
      atWork: 'в работе:',
      min: 'мин',
      works: 'Работы',
      items: 'Детали',
      recommendations: 'Рекомендации',
      noRows: 'Нет строк в документе',
      worksColumnIndex: '№',
      worksColumnWorkName: 'Наименование',
      worksColumnCount: 'н/ч',
      worksColumnPrice: 'грн/ч',
      worksColumnWorkerName: 'Исполнитель',
      worksColumnOnHand: '',
      worksColumnNorm: 'Норма',
      goodsColumnIndex: '№',
      goodsColumnProductName: 'Наименование детали',
      goodsColumnCount: 'К-во',
      goodsColumnMeasureName: 'Ед.',
      goodsColumnStorageName: 'Склад',
      goodsColumnOnHand: '',
      recommendationColumnIndex: '№',
      recommendationColumnWorkName: 'Наименование работы',
      recommendationColumnWorkerName: 'Исполнитель',
      recommendationColumnStatus: '',
      documentDataError: 'Ошибка получения данных документа',
      recommendationsSaved: 'Рекомендации записаны успешно',
      documentSaved: 'Документ записан успешно',
      documentSaveError: 'Ошибка записи документа',
      commentTo: 'Комментарий к',
      documentIsPostedError: 'Документ проведен и не сможет быть изменен!',
      countChanged: 'К-во изменилось!',
      reason: 'Причина обращения',
      questionnaireAbsent: 'Чек-лист не настроен',
    },
    carHistory: {
      carHistory: 'История авто',
      enterSearchValue:
        'Введите VIN-код или гос.номер автомобиля для поиска данных',
      carHistoryDataError: 'Ошибка получения данных истории авто',
    },
    questionnaireForm: {
      signSurvey: 'Подписать опрос',
      formColumnStartTime: 'Начало',
      formColumnEndTime: 'Окончание',
      formColumnWork: 'Работа',
      formDataError: 'Ошибка получения данных опроса',
      formSaveError: 'Ошибка записи опроса',
    },
    userCard: {
      startDateLabel: 'Карточка с',
      salary: 'зарплата',
      accruedSalary: 'начислено',
      salaryPaid: 'выплачено',
      endDateLabel: 'по',
      noDataError: 'Данные по выработке не найдены',
      workingOutPerMonth: 'Выработка за месяц',
      dataCompositionWarning:
        'в расчете участвуют только закрытые проведенные документы',
      dateDocTitle: 'Дата / ЗН',
      timesheetTitle: 'Учтено',
      factByDocumentsTitle: 'Счетчик по ЗН',
      factByWorksTitle: 'Счетчик по работам',
      usercardColumnWork: 'Работа',
      usercardColumnWorkingOut: 'Выработка',
      usercardColumnFact: 'Факт',
      userDataError: 'Ошибка: не удалось получить данные сотрудника',
      otherError: 'Ошибка',
      showFactColumns: 'показать значения счетчиков Старт/Стоп',
    },
    workPlan: {
      workPlanDataError: 'Ошибка получения данных планироващика',
      workPlanIsEmpty: 'План работ на текущую неделю не заполнен',
      carIsEmpty: 'Авто не указано',
      titleFrom: 'План работ с',
      titleTo: 'по',
      workCompleted: 'роботы завершены',
      docNotFound: 'Документ не найден',
    },
  },
  ua: {
    global: {
      appName: 'АРМ Механіка',
      logIn: 'Увійти',
      close: 'Закрити',
      cancel: 'Відмінити',
      save: 'Записати',
      add: 'Додати',
      recommendation: 'Рекомендація',
      works: 'Роботи',
      items: 'Деталі',
      date: 'Дата',
      number: '№',
      client: 'Клієнт',
      automobile: 'Автомобіль',
      plateNumber: 'держ. номер',
      months:
        'Січень,Лютий,Березень,Квітень,Травень,Червень,Липень,Серпень,Вересень,Жовтень,Листопад,Грудень',
      weekdays: "Неділя,Понеділок,Вівторок,Середа,Четвер,П'ятниця,Субота,",
      weekdaysShort: 'Нд,Пон,Вт,Ср,Чтв,Птн,Суб',
      onlyNumbers: 'Можна вводити лише цифри',
      search: 'Пошук',
      comment: 'Коментар',
      settings: 'налаштування',
      yield: 'Виробка',
      schedule: 'План',
      history: 'Історія',
      docList: 'Документи',
      pickPeriod: 'Оберіть період',
      periodFrom: 'Дата початку',
      periodTo: 'Кінцева дата',
      today: 'Сьогодні',
      week: 'Тиждень',
      prevWeek: 'Попередній тиждень',
      nextWeek: 'Наступний тиждень',
      month: 'Місяць',
      prevMonth: 'Попередній місяць',
      period: 'Період',
      yes: 'Так',
      no: 'Ні',
      camera: 'Камера',
    },
    login: {
      authorization: 'Авторизація',
      googleAuth: 'Авторизація за допомогою Google-аккаунта',
      barcodeLabel: 'Штрих-код беджа',
      pinLabel: 'PIN-код',
      demoAuth: 'Тестова база',
      barcodeRulesEmpty: 'Введіть штрих-код беджа',
      barcodeRulesError: 'Некоректний формат штрих-кода',
      pinRulesEmpty: 'Введіть PIN-код беджа',
      pinRulesError: 'Некоректний формат PIN-кода',
      logInAs: 'Ви увійшли як',
      waitFor: 'Дочекайтесь завершення завантаження даних',
      entryError: 'Помилка входу',
      settingsError: 'Помилка отримання налаштувань сервера',
      authError: 'Помилка аутентифікації',
      logoutConfirm: 'Ви впевнені що хочете вийти з додатка?',
    },
    settings: {
      settings: 'Налаштування додатку',
      serverAddress: 'Адреса сервера',
      autoLogOut: 'Виходити автоматично',
    },
    docList: {
      listFor: 'Дата',
      listInWork: 'НЗ в роботі',
      listArchive: 'Архів НЗ',
      searchLabel: '№ док. / держ. номер',
      barcodeLabel: 'Штрих-код документу',
      noDocs: 'Документи за обрану дату не знайдені',
      listSettings: 'Налаштування списку',
      rememberDate: "Запам'ятати дату",
      docSelectionError: 'Помилка виборки документів',
      docGettingError: 'Помилка отримання документа',
      docNotFound: 'Документ не знайдено',
      docDataError: 'Помилка отримання даних документа',
    },
    docZN: {
      ZN: 'НЗ',
      dated: 'від',
      atWork: 'в роботі:',
      min: 'мін',
      works: 'Роботи',
      items: 'Деталі',
      recommendations: 'Рекомендації',
      noRows: 'Дані відсутні',
      worksColumnIndex: '№',
      worksColumnWorkName: 'Найменування',
      worksColumnCount: 'н/г',
      worksColumnPrice: 'грн/г',
      worksColumnWorkerName: 'Виконавець',
      worksColumnOnHand: '',
      worksColumnNorm: 'Норма',
      goodsColumnIndex: '№',
      goodsColumnProductName: 'Найменування деталі',
      goodsColumnCount: 'К-сть',
      goodsColumnMeasureName: 'Од.',
      goodsColumnStorageName: 'Склад',
      goodsColumnOnHand: '',
      recommendationColumnIndex: '№',
      recommendationColumnWorkName: 'Найменування роботи',
      recommendationColumnWorkerName: 'Виконавець',
      recommendationColumnStatus: '',
      documentDataError: 'Помилка отримання даних документа',
      recommendationsSaved: 'Рекомендації збережені успішно',
      documentSaved: 'Документ збережено успішно',
      documentSaveError: 'Помилка збереження документа',
      commentTo: 'Коментар до',
      documentIsPostedError: 'Документ проведен і не може бути змінений!',
      countChanged: 'Кількість змінено!',
      reason: 'Причина звернення',
      questionnaireAbsent: 'Чек-лист не налагоджен',
    },
    carHistory: {
      carHistory: 'Істория авто',
      enterSearchValue:
        'Введіть VIN-код або держ.номер автомобіля для пошуку даних',
      carHistoryDataError: 'Помилка отримання даних історії авто',
    },
    questionnaireForm: {
      signSurvey: 'Підписати опитування',
      formColumnStartTime: 'Начало',
      formColumnEndTime: 'Завершення',
      formColumnWork: 'Робота',
      formDataError: 'Помилка отримання даних опитування',
      formSaveError: 'Помилка збереження опитування',
    },
    userCard: {
      startDateLabel: 'Картка з',
      salary: 'зарплата',
      accruedSalary: 'нараховано',
      salaryPaid: 'виплачено',
      endDateLabel: 'по',
      noDataError: 'Дані по виробці не знайдені',
      workingOutPerMonth: 'Виробка за місяць',
      dataCompositionWarning:
        'в розрахунковому періоді беруть участь лише закриті проведені документи',
      dateDocTitle: 'Дата / НЗ',
      timesheetTitle: 'Враховано',
      factByDocumentsTitle: 'Лічильник по НЗ',
      factByWorksTitle: 'Лічильник по роботам',
      usercardColumnWork: 'Робота',
      usercardColumnWorkingOut: 'Виробка',
      usercardColumnFact: 'Факт',
      userDataError: 'Помилка: неможливо отримати дані співробітника',
      otherError: 'Помилка',
      showFactColumns: 'відображати значення лічильників Старт/Стоп',
    },
    workPlan: {
      workPlanDataError: 'Помилка завантаження даних планувальника',
      workPlanIsEmpty: 'План робіт на поточний тиждень порожній',
      carIsEmpty: 'Авто не вказано',
      titleFrom: 'План робіт з',
      titleTo: 'по',
      workCompleted: 'роботи завершено',
      docNotFound: 'Документ не знайдено',
    },
  },
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'ua', // set locale
  messages, // set locale messages
})

export default i18n
